import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { RestaurantService } from '../services/restaurant.service';
import { isFeatureActive } from '../utils/feature-flag.util';

/**
 * Gates a route on the feature flag named in its `data.featureFlag`. Reads the
 * flag list loaded once for the app (`loadFeatureFlags`), never a single-flag
 * lookup. Flag off, missing, or the flags can't be loaded → the dashboard.
 */
export const FeatureFlagGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const restaurantService = inject(RestaurantService);
  const key: string | undefined = route.data?.['featureFlag'];

  if (!key) {
    return true;
  }
  return restaurantService
    .loadFeatureFlags()
    .pipe(
      map((flags) =>
        isFeatureActive(flags, key) ? true : router.createUrlTree(['main', 'dashboard']),
      ),
    );
};
